import { Empty, Table } from "antd";
import { UserGroupContract } from "../../../models/UserGroupContract";

export type AccountsUserGroupsTabProps = {
  userGroupContract: UserGroupContract;
};

/**
 * This page lists all company accounts.
 * @param param0
 * @returns
 */
export function AccountsUserGroupContractView({userGroupContract}: AccountsUserGroupsTabProps) {

  const dataSource = userGroupContract.members?.map((m) => ({
    key: m.userId,
    username: m.username,
    name: [m.user?.firstName, m.user?.lastName].filter((s) => s !== null && s!== undefined && s.trim() !== '').join(' '),
    startDate: m.startDate,
    endDate: m.endDate,
  })) ?? [];

  const columns = [
    {
      title: 'Epostadress',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Namn',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Inflytt',
      dataIndex: 'startDate',
      key: 'startDate',
    },
    {
      title: 'Utflytt',
      dataIndex: 'endDate',
      key: 'endDate',
    },
  ];

  return <>
    <Table
      columns={columns}
      dataSource={dataSource}
      pagination={dataSource.length > 10 ? undefined : false}
      locale={{
        emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Inga boende" />
      }}
    />
  </>;

}